<template>
  <CCardBody>
    <CDataTable
      :items="items"
      :fields="fields"
      column-filter
      table-filter
      items-per-page-select
      :items-per-page="20"
      hover
      sorter
      pagination
      :responsive="false"
    >
      <template #show_details="{item}">
        <td class="py-2">
          <CDropdown togglerText color="secondary">
            <CDropdownItem :to="{name: 'AppUser', params: {userId: item.uid, mode: 'view'}}">View</CDropdownItem>
            <CDropdownItem v-if="item.disabled" @click="activateDeactivateUser(item.uid)">Enable</CDropdownItem>
            <CDropdownItem v-if="!item.disabled" @click="activateDeactivateUser(item.uid)">Disable</CDropdownItem>
          </CDropdown>
        </td>
      </template>
    </CDataTable>
  </CCardBody>
</template>
<script>
const fields = [
  { key: "displayName", _style: "min-width:200px" },
  { key: "email", _style: "min-width:100px;" },
  { key: "phoneNumber", _style: "min-width:100px;" },
  {
    key: "show_details",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false,
  },
];

export default {
  name: "Users",
  data() {
    return {
      items: [],
      fields,
      details: [],
      collapseDuration: 0,
    };
  },
  methods: {
    getAppUsers() {
      this.apiGetSecure(process.env.VUE_APP_API_HOST + "/web/secure/users")
        .then((response) => response.json())
        .then((data) => (this.items = data));
    },

    activateDeactivateUser(uid) {
      
      this.apiGetSecure(
        process.env.VUE_APP_API_HOST +
          "/web/secure/user/activate_deactive/" + uid
      )
        .then((response) => response.json())
        .then((data) => {
          this.getAppUsers();
        });
    },
  },
  mounted() {
    this.getAppUsers();
  },
};
</script>